import { defineStore } from "pinia"
import { useProviderStore } from "./provider";
import { useMetricsStore } from "./metrics";
import { useCredentialStore } from "./credential";

export const useGeneralStore = defineStore("general", () => {
  const provider = useProviderStore();
  const credential = useCredentialStore();
  const metrics = useMetricsStore();

  const resetProvider = () => {
    provider.resetProvider();
    credential.resetCredentials();
  };

  const resetStores = () => {
    provider.resetStore();
    credential.resetStore();
    metrics.resetStore();
  };

  return {
    resetProvider,
    resetStores,
  }
})

